'use client'

import Breadcrumb from '@/components/breadcrumb'
import { getCaseStudiesHref } from '@/components/links/case'
import { CaseStudiesFilter as CaseStudiesFilterType } from '@/entities/caseStudies'
import { Menus } from '@/entities/menus'
import { parseQuery } from '@/lib/fetch/caseStudies'
import CaseStudiesRoute from '@/lib/routes/caseStudies'
import { toSlug } from '@/lib/url'
import { map } from 'lodash-es'
import { useRouter } from 'next/navigation'
import { useRef } from 'react'

export function CaseStudiesFilterContent({
  data,
  query,
  menu,
}: {
  data: CaseStudiesFilterType
  query?: string
  menu: Menus
}) {
  const { locationOptions, industryOptions } = getOptions(data)
  const { location, industry } = parseQuery(query)

  const formRef = useRef<HTMLFormElement>(null)
  const router = useRouter()
  function handlerFormSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const locationValue = formData.get('location') as string
    const industryValue = formData.get('industry') as string
    const route = new CaseStudiesRoute()

    const location = locationOptions.find(
      (item) => item.value === locationValue
    )
    const industry = industryOptions.find(
      (item) => item.value === industryValue
    )

    if (location) {
      route.setVal('location', toSlug(location.label, location.value))
    }
    if (industry) {
      route.setVal('industry', toSlug(industry.label, industry.value))
    }
    route.setVal('page', 1)
    router.replace(getCaseStudiesHref(route.getSlug(), menu), {
      scroll: false,
    })
  }
  function filterChange() {
    formRef.current?.requestSubmit()
  }

  return (
    <section className='p-4 lg:py-0 lg:h-17.5 border-b border-secondary/20 lg:px-7.5 flex flex-col gap-y-3 lg:flex-row lg:items-center lg:justify-between'>
      <Breadcrumb home>{menu.name}</Breadcrumb>
      <form
        className='flex gap-x-2.5 items-center'
        onSubmit={handlerFormSubmit}
        ref={formRef}
      >
        <span>Location</span>
        <select
          className='flex-1 lg:w-55 h-8 border border-secondary/30 rounded-sm'
          name='location'
          onChange={filterChange}
          defaultValue={location || ''}
        >
          <option value=''>All</option>
          {locationOptions.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        <span className='sm:ml-7.5 lg:ml-12.5'>Industry</span>
        <select
          className='flex-1 lg:w-55 h-8 border border-secondary/30 rounded-sm'
          name='industry'
          onChange={filterChange}
          defaultValue={industry || ''}
        >
          <option value=''>All</option>
          {industryOptions.map((item, index) => (
            <option key={index} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
      </form>
    </section>
  )
}

function getOptions(data: CaseStudiesFilterType) {
  const locationOptions = map(data.location, (value, key) => ({
    label: value,
    value: key,
  }))
  const industryOptions = map(data.industry, (value, key) => ({
    label: value,
    value: key,
  }))
  return { locationOptions, industryOptions }
}
